import React, {
  lazy,
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { TostMsg } from "../../../App";
import { Stepper } from "primereact/stepper";
import { StepperPanel } from "primereact/stepperpanel";
import { Button } from "primereact/button";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";
import * as XLSX from "xlsx";
import {
  getUploadEmployees,
  getValidateXmlData,
} from "../EmployeeList/Service/employeeService";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
const ComponentLoader = React.memo(
  lazy(() => import("../../../Shared/Sidebar/ComponentLoader"))
);
const defaultImage = "/images/no-data-found/announcement01.jpg";
function UploadEmployee() {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const toster = useContext(TostMsg);
  const [Isloading, setIsloading] = useState(false);
  const fileInputRef = useRef(null);
  const [file, setFile] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const [employeeXML, setEmployeeXML] = useState([]);
  const [xmlVlidResponse, setXmlVlidResponse] = useState([]);
  const [xmlInvlidResponse, setXmlInvlidResponse] = useState([]);
  const [xmlUploadData, setXmlUploadData] = useState([]);
  const [finelSaveRecord, setFinelSaveRecord] = useState([]);
  const [showValidRecord, setShowValidRecord] = useState(false);
  const [downloadExcelExample, setDownloadExcelExample] = useState(false);
  const [emailButtonName, setEmailButtonName] = useState("");
  const [errorUploadExcel, setErrorUploadExcel] = useState("");
  const [isExcelValid, setIsExcelValid] = useState(false);
  const [uploadSuccessMessage, setUploadSuccessMessage] = useState("");
  const [showSuccessMessage, setShowSuccessMessage] = useState("");
  const history = useHistory();
  const requiredFields = [
    "FirstName",
    "LastName",
    "EmploymentId",
    "DateOfJoining",
    "CountryCode",
    "MobileNumber",
    "OrganizationEmail",
    "PersonalEmail",
  ];

  const toggleShowValidRecord = () => {
    setShowValidRecord((prev) => !prev);
  };

  useEffect(() => {
    GetMasterSystemAlertList("OrgGenie_Bulk_Employee_Import_Template_Path", 1);
    GetMasterSystemAlertList("Upload_Success_Button_Text", 2);
    GetMasterSystemAlertList("File_Upload_Error", 3);
    GetMasterSystemAlertList("Upload_Validation_Success_Message", 4);
    GetMasterSystemAlertList("Upload_Success_Message", 5);
  }, []);

  useEffect(() => { }, [file]);

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type === 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type === 1) {
        setDownloadExcelExample(msg?.Desc);
      } else if (msg?.Name == message && type === 2) {
        setEmailButtonName(msg?.Desc);
      } else if (msg?.Name == message && type === 3) {
        setErrorUploadExcel(msg?.Desc);
      } else if (msg?.Name == message && type === 4) {
        setUploadSuccessMessage(msg?.Desc);
      } else if (msg?.Name == message && type === 5) {
        setShowSuccessMessage(msg?.Desc);
      }
    });
  }, []);

  const handleFileClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setFile(event.target.files);
    if (!file) return;

    const validTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
      "text/csv",
    ];

    if (!validTypes.includes(file.type)) {
      alert("Invalid file type. Please upload a CSV or Excel file.");
      return;
    }

    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array", cellDates: true });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];

      const jsonData = XLSX.utils.sheet_to_json(sheet, {
        defval: "",
        raw: false,
      });

      let xml = "<root>";
      jsonData.forEach((row) => {
        xml += "  <item>";
        for (const key in row) {
          let value = row[key];
          if (
            value !== null &&
            value !== undefined &&
            value.toString().trim() !== ""
          ) {
            const sanitizedKey = key.replace(/\s+/g, "_");
            let stringValue = value.toString().trim();
            const possibleFormats = [
              "DD-MM-YYYY",
              "MM-DD-YYYY",
              "YYYY-MM-DD",
              "DD/MM/YYYY",
              "MM/YYYY/DD",
              "MM-YYYY-DD",
              "YYYY/DD/MM",
              "YYYY.MM.DD",
              "DD.MM.YYYY",
              "MM.DD.YYYY",
              "MM-DD-YY",
            ];

            let parsed = null;

            for (const format of possibleFormats) {
              const d = dayjs(stringValue, format, true);
              if (d.isValid()) {
                parsed = d.format("YYYY/MM/DD");
                break;
              }
            }

            const cleanValue = (parsed || stringValue)
              .replace(/\\+/g, "")
              .replace(/^"(.*)"$/, "$1")
              .trim();

            xml += `    <${sanitizedKey}>${cleanValue}</${sanitizedKey}>`;
          }
        }
        xml += "  </item>";
      });
      xml += "</root>";
      console.log(xml, 'succuss');
      setEmployeeXML(xml);
    };

    reader.readAsArrayBuffer(file);
  };

  function validateEmployeeItems(xmlString) {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlString, "text/xml");
    const items = xmlDoc.getElementsByTagName("item");

    if (items.length === 0) {
      return { isValid: false, message: "No <item> entries found in the XML." };
    }

    const errors = [];

    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      const missingFields = [];

      for (const field of requiredFields) {
        const element = item.getElementsByTagName(field)[0];
        const value = element?.textContent?.trim();

        if (!value) {
          missingFields.push(field);
        }
      }

      if (missingFields.length > 0) {
        errors.push(`Item #${i + 1} missing: ${missingFields.join(", ")}`);
      }
    }

    if (errors.length > 0) {
      return { isValid: false, message: errors.join("\n") };
    }

    return { isValid: true };
  }

  async function updateExcelRecord() {
    setIsloading(true);
    const result = validateEmployeeItems(employeeXML);
    const params = {
      XmlData: employeeXML,
      LoggedInUserId: userDetails?.EmpId,
      OrgId: userDetails?.OrgId,
    };
    if (!result.isValid) {
      setIsExcelValid(true);
      setIsloading(false);
      return;
    }
    try {
      const responseData = await getUploadEmployees(params);
      if (responseData?.Data?.ReturnValue === 1) {
        setXmlVlidResponse(responseData?.Data?.XmlListValid);
        setXmlInvlidResponse(responseData?.Data?.XmlListInvalid);
        setActiveStep(prev => prev + 1);
      } else if (responseData?.Data?.ReturnValue === 0) {
        setXmlVlidResponse(responseData?.Data?.XmlListValid);
        setXmlInvlidResponse(responseData?.Data?.XmlListInvalid);
        setActiveStep(prev => prev + 1);
      } else {
        setXmlVlidResponse(responseData?.Data?.XmlListValid);
        setXmlInvlidResponse(responseData?.Data?.XmlListInvalid);
        setActiveStep(prev => prev + 1);
      }
      setXmlUploadData(responseData?.Data);
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST.ExcelUploadError);
    } finally {
      setIsloading(false);
    }
  }

  async function submitValidateXmlData() {
    setIsloading(true);
    if (xmlUploadData) {
      const params = {
        UploadBatch: xmlUploadData.UploadBatchNumber ?? "",
        LoggedInUserId: userDetails?.EmpId,
        OrgId: userDetails?.OrgId,
        BranchId: userDetails?.BranchId,
      };
      try {
        let xmlValidateData = await getValidateXmlData(params);
        setActiveStep(prev => prev + 1);
        setFinelSaveRecord(xmlValidateData?.Data);
        GetMasterSystemAlertList("Upload_Success_Message", 0);
        setIsloading(false);
      } catch (error) {
        setIsloading(false);
      }
    }
  }

  function goForIndivisible() {
    history.push("/Employee/Add");
  }

  function goToListPage() {
    history.push("/TeamDirectory");
  }

  function clearFileData() {
    setFile([]);
    setIsExcelValid(false);
    fileInputRef.current.value = "";
  }

  function uploadAgain() {
    setFile([]);
    setIsExcelValid(false);
    setActiveStep(0);
  }

  return (
    <>
      <div className="container-fluid  position-relation">
        <div className="row">
          <div className="edit-ticket mb-4">
            <div className="w-100">
              <div className="row justify-content-center">
                <div className="col-lg-12">
                  <div className="Upload-user-profile-bx">
                    <div className="me-auto">
                      <h2 className="font-w600 mb-0">Upload Employees</h2>
                    </div>
                    <div className="panels mt-3">
                      <div className="upload-card">
                      <Stepper
                        activeStep={activeStep}
                        onStepChange={(e) => setActiveStep(e.index)}
                        className="disable-step-click"
                        style={{ flexBasis: "50rem" }}
                      >
                        <StepperPanel header="Upload">
                          <div className="flex flex-column h-12rem">
                            <div className="Upload-user-profile-bx">
                              <div className="text-left">
                                <h5>Upload Employees</h5>
                                <p className="description">
                                  Before you upload your files below, make sure
                                  your file is
                                  <span className="highlight"> correct</span>.
                                  OrgGenie will let you know when your records{" "}
                                  are{" "}
                                  <span className="highlight">duplicates</span>{" "}
                                  or
                                  <span className="highlight"> invalid</span>.
                                </p>
                              </div>
                              {file.length === 0 ? (
                                <>
                                  <div className="import-section mt-3">
                                    <h3>Import file</h3>
                                    <div
                                      className="upload-box"
                                      onClick={handleFileClick}
                                      style={{
                                        cursor: "pointer",
                                        border: "2px dashed #ccc",
                                        padding: "11px",
                                        textAlign: "center",
                                      }}
                                    >
                                      <div
                                        className="upload-icon"
                                        style={{ fontSize: "2rem" }}
                                      >
                                        👤
                                      </div>
                                      <p className="mb-0">
                                        Drag and drop or
                                        <span
                                          style={{
                                            color: "blue",
                                            textDecoration: "underline",
                                          }}
                                        >
                                          {" "}
                                          choose a file{" "}
                                        </span>
                                        to upload your Employees.
                                        <br />
                                        All .csv, .xlsx, and .xls file types are
                                        supported.
                                      </p>
                                      <input
                                        type="file"
                                        ref={fileInputRef}
                                        onChange={handleFileChange}
                                        accept=".csv,.xlsx,.xls"
                                        style={{ display: "none" }}
                                      />
                                    </div>
                                    <div className="mt-2">
                                      <a
                                        href={downloadExcelExample}
                                        className="example-link text-end"
                                        target="blank"
                                        download
                                      >
                                        Download Template file
                                      </a>
                                    </div>
                                    <div className="or-section">
                                      <span>OR</span>
                                    </div>
                                    <Link
                                      to="/Employee/Add"
                                      className="btn btn-block btn-danger w-auto" style={{float:"right"}}
                                    >
                                      Enter Employee Details Individually
                                    </Link>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className="import-section mt-3">
                                    <div
                                      className="upload-box"
                                      style={{
                                        border: "2px dashed #ccc",
                                        padding: "20px",
                                        textAlign: "center",
                                      }}
                                    >
                                      <div
                                        style={{
                                          position: "relative",
                                          display: "Block",
                                        }}
                                      >
                                        <div className="mb-2 ">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="30"
                                            height="30"
                                            fill="currentColor"
                                            className="bi bi-filetype-pdf"
                                            viewBox="0 0 16 16"
                                          >
                                            <path
                                              fill-rule="evenodd"
                                              d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM1.6 11.85H0v3.999h.791v-1.342h.803q.43 0 .732-.173.305-.175.463-.474a1.4 1.4 0 0 0 .161-.677q0-.375-.158-.677a1.2 1.2 0 0 0-.46-.477q-.3-.18-.732-.179m.545 1.333a.8.8 0 0 1-.085.38.57.57 0 0 1-.238.241.8.8 0 0 1-.375.082H.788V12.48h.66q.327 0 .512.181.185.183.185.522m1.217-1.333v3.999h1.46q.602 0 .998-.237a1.45 1.45 0 0 0 .595-.689q.196-.45.196-1.084 0-.63-.196-1.075a1.43 1.43 0 0 0-.589-.68q-.396-.234-1.005-.234zm.791.645h.563q.371 0 .609.152a.9.9 0 0 1 .354.454q.118.302.118.753a2.3 2.3 0 0 1-.068.592 1.1 1.1 0 0 1-.196.422.8.8 0 0 1-.334.252 1.3 1.3 0 0 1-.483.082h-.563zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638z"
                                            />
                                          </svg>
                                        </div>
                                      </div>
                                      <div className="position-relative hover-block-area">
                                        <span
                                          className="btn btn-danger cross-btn-all small-rounded-cross"
                                          onClick={() => clearFileData()}
                                        >
                                          ×
                                        </span>
                                        <p
                                          onClick={handleFileClick}
                                          className=" d-inline"
                                        >
                                          {file[0]?.name}
                                          <span
                                            style={{
                                              color: "blue",
                                              textDecoration: "underline",
                                            }}
                                          >
                                            <br />
                                            choose Other file{" "}
                                          </span>
                                        </p>
                                      </div>
                                      <input
                                        type="file"
                                        ref={fileInputRef}
                                        onChange={handleFileChange}
                                        accept=".csv,.xlsx,.xls"
                                        style={{ display: "none" }}
                                      />
                                    </div>
                                    <a
                                      href="/OrgEmployee_Upload.xlsx"
                                      className="example-link text-end"
                                      download
                                    >
                                      Download example file
                                    </a>
                                    {isExcelValid && (
                                      <div className="invalid-info-area">
                                        {errorUploadExcel}
                                      </div>
                                    )}
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                          <div className="pt-3 justify-content-between text-right">
                            <div
                              className={
                                file.length > 0
                                  ? "d-flex  justify-content-between mt-2}"
                                  : ""
                              }
                            >
                              {file.length > 0 && (
                                <Button
                                  severity="secondary"
                                  className="btn btn-danger "
                                  onClick={() => goForIndivisible()}
                                >
                                  Enter Employee Details Individually
                                </Button>
                              )}
                              <Button
                                label="Next"
                                className="publish-click w-auto"
                                iconPos="right"
                                onClick={() => updateExcelRecord()}
                                disabled={file.length === 0}
                              />
                            </div>
                          </div>
                        </StepperPanel>
                        <StepperPanel header="Review">
                          <div className=" h-12rem">
                            {xmlInvlidResponse.length > 0 && (
                              <div>
                                <div className="invalid-info-area">
                                  We found ({xmlInvlidResponse.length}) invalid
                                  <span className="ps-2">
                                    {xmlInvlidResponse.length === 1
                                      ? "record"
                                      : "records"}
                                  </span>
                                </div>
                                <table className="table table-bordered table-hover">
                                  <thead>
                                    <tr>
                                      <th scope="col">#</th>
                                      <th scope="col" className="output-column">
                                        Output
                                      </th>
                                      <th scope="col">First Name</th>
                                      <th scope="col">Last Name</th>
                                      <th scope="col">Employment Id</th>
                                      <th scope="col">Date Of Joining</th>
                                      <th scope="col">Phone Number</th>
                                      <th scope="col">Official Email</th>
                                      <th scope="col">Personal Email</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {xmlInvlidResponse?.map((item, index) => (
                                      <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td
                                          style={{
                                            color: "red",
                                            minWidth: "200px",
                                          }}
                                        >
                                          {item.Message}
                                        </td>
                                        <td>{item.FirstName}</td>
                                        <td>{item.LastName}</td>
                                        <td>{item.EmploymentId}</td>
                                        <td>
                                          {moment(item.DateOfJoining).format(
                                            "MMM DD YYYY"
                                          )}
                                        </td>
                                        <td>{item.MobileNumber}</td>
                                        <td>{item.OrganizationEmail}</td>
                                        <td>{item.PersonalEmail}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>

                          <div>
                            <div className="d-flex pt-3 justify-content-between align-items-center">
                              {xmlVlidResponse.length > 0 && (
                                <p className="fs-7 text-black mb-0">
                                  ({xmlVlidResponse.length}){" "}
                                  {uploadSuccessMessage}
                                </p>
                              )}
                              <div>
                                <Button
                                  label="Back"
                                  severity="secondary"
                                  className="cancelbutton bg-dark text-white"
                                  onClick={() => setActiveStep(prev => prev - 1)}
                                />
                                <Button
                                  label="Next"
                                  className="publish-click w-auto"
                                  iconPos="right"
                                  onClick={() => submitValidateXmlData()}
                                  disabled={xmlVlidResponse.length === 0}
                                />
                              </div>
                            </div>
                          </div>
                          {xmlVlidResponse.length > 0 && (
                            <div className="box-expended-area mt-4">
                              <div className="accordion" id="accordionExample">
                                <div className="accordion-item">
                                  <h2 className="accordion-header" id="headingOne">
                                    <button
                                      onClick={toggleShowValidRecord}
                                      className="accordion-button"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#collapseOne"
                                      aria-expanded="true"
                                      aria-controls="collapseOne"
                                    >
                                      Valid Record
                                    </button>
                                  </h2>
                                  <div
                                    id="collapseOne"
                                    className="accordion-collapse collapse show"
                                    aria-labelledby="headingOne"
                                    data-bs-parent="#accordionExample"
                                  >
                                    <div className="accordion-body">
                                      {showValidRecord && (
                                        <table className="table table-bordered table-hover">
                                          <thead>
                                            <tr>
                                              <th scope="col">#</th>
                                              <th scope="col">First Name</th>
                                              <th scope="col">Last Name</th>
                                              <th scope="col">Employment Id</th>
                                              <th scope="col">
                                                Date Of Joining
                                              </th>
                                              <th scope="col">Phone Number</th>
                                              <th scope="col">
                                                Official Email
                                              </th>
                                              <th scope="col">
                                                Personal Email
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {xmlVlidResponse?.map(
                                              (item, index) => (
                                                <tr key={index}>
                                                  <td>{index + 1}</td>
                                                  <td>{item.FirstName}</td>
                                                  <td>{item.LastName}</td>
                                                  <td>{item.EmploymentId}</td>
                                                  <td>
                                                    {moment(
                                                      item.DateOfJoining
                                                    ).format("MMM DD YYYY")}
                                                  </td>
                                                  <td>{item.MobileNumber}</td>
                                                  <td>
                                                    {item.OrganizationEmail}
                                                  </td>
                                                  <td>{item.PersonalEmail}</td>
                                                </tr>
                                              )
                                            )}
                                          </tbody>
                                        </table>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </StepperPanel>
                        <StepperPanel header="Confirm">
                          <div className=" h-12rem">
                            <p>{showSuccessMessage}</p>
                          </div>

                          <div className="flex pt-5 justify-content-between text-right">
                            <Button
                              label="Back"
                              severity="secondary"
                              className="cancelbutton bg-dark text-white"
                              onClick={() => uploadAgain()}
                            />
                            <Button
                              label={emailButtonName}
                              className="savebutton w-auto"
                              onClick={() => goToListPage()}
                            />
                          </div>
                        </StepperPanel>
                      </Stepper>
                      </div>
                      <div className="vr-card">
                        <div className="vr-header">
                          <div className="vr-header-icon">
                            <svg width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path><polyline points="9 12 11 14 15 10"></polyline></svg>
                          </div>
                          <div className="vr-header-text">
                            <h3>Validation rules</h3>
                            <p>Lorem ipsum dolor sit amet, consectetu.</p>
                          </div>
                        </div>

                        <div className="vr-body">

                          <div className="vr-section">
                            <div className="vr-section-label">Required fields</div>
                            <div className="vr-rule">
                              <div className="vr-rule-icon req">
                                <svg width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"></polyline></svg>
                              </div>
                              <span className="vr-rule-text">No empty cells in: First Name, Last Name, Employment ID, Mobile, Date of Joining</span>
                            </div>
                          </div>

                          <div className="vr-divider"></div>
                          <div className="vr-section">
                            <div className="vr-section-label">Format checks</div>
                            <div className="vr-rule">
                              <div className="vr-rule-icon fmt">
                                <svg width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"></polyline></svg>
                              </div>
                              <span className="vr-rule-text">Mobile number is exactly 10 numeric digits</span>
                            </div>
                            <div className="vr-rule">
                              <div className="vr-rule-icon fmt">
                                <svg width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"></polyline></svg>
                              </div>
                              <span className="vr-rule-text">Date of joining is not a future date</span>
                            </div>
                            <div className="vr-rule">
                              <div className="vr-rule-icon fmt">
                                <svg width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"></polyline></svg>
                              </div>
                              <span className="vr-rule-text">Date format is YYYY-MM-DD</span>
                            </div>
                          </div>

                          <div className="vr-divider"></div>
                          <div className="vr-section">
                            <div className="vr-section-label">Duplicate checks — within file</div>
                            <div className="vr-rule">
                              <div className="vr-rule-icon dup">
                                <svg width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"></polyline></svg>
                              </div>
                              <span className="vr-rule-text">No duplicate organisation emails within the file</span>
                            </div>
                            <div className="vr-rule">
                              <div className="vr-rule-icon dup">
                                <svg width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"></polyline></svg>
                              </div>
                              <span className="vr-rule-text">No duplicate mobile numbers within the file</span>
                            </div>
                            <div className="vr-rule">
                              <div className="vr-rule-icon dup">
                                <svg width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"></polyline></svg>
                              </div>
                              <span className="vr-rule-text">No duplicate employment IDs within the file</span>
                            </div>
                            <div className="vr-rule">
                              <div className="vr-rule-icon dup">
                                <svg width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"></polyline></svg>
                              </div>
                              <span className="vr-rule-text">No duplicate personal emails within the file</span>
                            </div>
                          </div>

                          <div className="vr-divider"></div>
                          <div className="vr-section">
                            <div className="vr-section-label">System-level checks</div>
                            <div className="vr-rule">
                              <div className="vr-rule-icon sys">
                                <svg width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"></polyline></svg>
                              </div>
                              <span className="vr-rule-text">Organisation email not already registered in the system</span>
                            </div>
                            <div className="vr-rule">
                              <div className="vr-rule-icon sys">
                                <svg width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"></polyline></svg>
                              </div>
                              <span className="vr-rule-text">Employment ID not already registered for this organisation</span>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {Isloading ? (
          <Suspense >
            <ComponentLoader />
          </Suspense>
        ) : (
          ""
        )}
      </div>
    </>
  );
}

export default UploadEmployee;
